import "./TechnologyAndSaas.module.css";
import Header from "@/reusable_sections/Header";
import IndustryHub from "./sections/IndustryHub";
import SoftwareSeo from "./sections/SoftwareSeo";
import RelatedServices from "./sections/RelatedServices";
import Footer from "@/reusable_sections/Footer";
export default function TechnologyAndSaasPage() {
  return <div>
      <Header />
      <IndustryHub />
      <SoftwareSeo />
      <RelatedServices />
      <Footer />
    </div>;
}